import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section id="Contact" className="contact-section">
      <h2>Contact Us</h2>
      <p>Phone: +977 9745666634 9860583100</p>
      <p>Email: coffeedhara2022@gmail.com</p>
      <p>Address: New Plaza Road, Putalisadak, Kathmandu, Nepal</p>
    </section>
  );
}

export default Contact;
